import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useCambioInstalacion } from "./useCambioInstalacion";
import ErrorInput from "../../components/ui/ErrorInput";
import { InputSelect } from "../../components/formComponents/inputSelect";
import Spinner from "../../components/ui/Spinner";

export const CambioDeInstalacion = props => {
  const { unidadesNegocio, getUnidadesNegocio, instalaciones, getInstalaciones } = useCambioInstalacion();
  const [buscando, setBuscando] = useState(false);
  const { formik } = props;

  CambioDeInstalacion.propTypes = { formik: PropTypes.object.isRequired };

  const funciocita = async () => {
    if (formik.values.unidad_destino) {
      setBuscando(true);
      await getInstalaciones(formik.values.unidad_destino);
      setBuscando(false);

      formik.setValues({ ...formik.values, instalacion_administrador: "" });
      const inputCont = document.querySelector("div#instalacion_administrador");

      if (inputCont) {
        const btn_X = inputCont.querySelector(".limpiarSelect__indicator>svg");
        const event = new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window });

        btn_X.dispatchEvent(event);
      }
    }
  };

  useEffect(() => {
    funciocita();
  }, [formik.values.unidad_destino]);

  useEffect(() => {
    getUnidadesNegocio();
  }, []);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between">
          <label htmlFor="unidad_destino">Unidad de negocio *</label>
          {formik.errors.unidad_destino !== undefined && formik.touched.unidad_destino !== undefined && <ErrorInput touched={formik.touched.unidad_destino} error={formik.errors.unidad_destino} />}
        </div>

        <select disabled={!formik.values.fecha_inicio_cambio || formik.errors.fecha_inicio_cambio} id="unidadNegocio" className="form-select" name="unidad_destino" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.unidad_destino}>
          <option value="">Seleccione</option>
          {unidadesNegocio.map((el, idx) => (
            <option value={el.id} key={el.id}>
              {el.nombre}
            </option>
          ))}
        </select>
      </div>
      <div>
        {buscando ? (
          <div style={{ columnGap: "10px" }} className="d-flex align-items-center justify-content-center flex-row">
            <p style={{ fontSize: "17px" }} className="mb-2">
              Cargando instalaciones
            </p>
            <Spinner clases="m-2 p-2" />
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-between">
              <label htmlFor="instalacion_administrador">Instalación *</label>
              {formik.errors.instalacion_administrador !== undefined && formik.touched.instalacion_administrador !== undefined && <ErrorInput touched={formik.touched.instalacion_administrador} error={formik.errors.instalacion_administrador} />}
            </div>
            <InputSelect llave_texto="NOMBRE_UO" id="instalacion_administrador" llave_valor={null} formik={formik} arr={instalaciones} />
          </>
        )}
      </div>
    </>
  );
};
